import React from "react";
import ReactGA from "react-ga";
import { GlobalProvider } from "./context/GlobalState";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import ScrollToTop from "./components/ScrollToTop";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFile as faFileRegular } from "@fortawesome/free-regular-svg-icons";
import {
  faPlayCircle,
  faCheckCircle,
  faCircle,
  faChevronRight,
  faChevronLeft,
  faEye,
  faTrashAlt,
  faHome,
  faCode,
  faPhone,
  faCog,
  faUser,
  faDotCircle,
  faTimes,
  faArrowCircleRight,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faPlay,
  faCreditCard,
  faPlus,
  faToggleOn,
  faPercent,
  faSyncAlt,
  faItalic,
  faUsers,
  faCheck,
  faPowerOff,
  faEnvelope,
  faMousePointer,
  faVideo,
  faMusic,
  faRocket,
  faFileArchive,
} from "@fortawesome/free-solid-svg-icons";
import {BuildProvider} from "./context/BuildSpotlightState";

library.add(
  faPlayCircle,
  faChevronRight,
  faCheckCircle,
  faEnvelope,
  faCreditCard,
  faDotCircle,
  faMusic,
  faCloudDownloadAlt,
  faCircle,
  faToggleOn,
  faVideo,
  faItalic,
  faSyncAlt,
  faUsers,
  faTrashAlt,
  faArrowCircleRight,
  faCloudUploadAlt,
  faTimes,
  faEye,
  faPlay,
  faHome,
  faUser,
  faPhone,
  faCode,
  faCog,
  faChevronLeft,
  faFileRegular,
  faPlus,
  faPercent,
  faCheck,
  faPowerOff,
  faCheck,
  faMousePointer,
  faRocket,
  faFileArchive
);

ReactGA.initialize("UA-164052432-2");

ReactDOM.render(
  <GlobalProvider>
    <BuildProvider>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </BuildProvider>
  </GlobalProvider>,
  document.getElementById("root")
);
